import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal } from 'apps/promo/actions/appAction';

import { ModalBody, ModalContainer, ModalViewport } from './styles';
import { LightDiskButton } from '../common/fromAuth/LightDiskButton/LightDiskButton';
import { LightNavBar } from '../common/fromAuth/LightNavBar/LightNavBar';

const PromoModalComponent = ({ canCloseModal = true, modalRef = null, ...props }) => {
    const ref = useRef(null);
    const [isScroll, setScroll] = useState(false);

    useEffect(() => {
        if (__isBrowser__) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            if (__isBrowser__ && !props.isShowPopup && !props.isShowModal) {
                document.body.style.overflow = '';
            }
        };
    }, [props.isShowModal, props.isShowPopup]);

    useEffect(() => {
        if (props.isShowPopup) {
            document.removeEventListener('keydown', keyPressHandler);
        } else if (canCloseModal && __isBrowser__) {
            document.addEventListener('keydown', keyPressHandler);
        }
        return () => {
            document.removeEventListener('keydown', keyPressHandler);
        };
    }, [props.isShowPopup]);

    const handleScroll = () => {
        setScroll(ref?.current?.scrollTop !== 0);
    };

    const keyPressHandler = (e) => {
        if (e.keyCode === 27 && !props.isShowPopup) {
            e.preventDefault();
            if (modalRef?.current) {
                modalRef.current?.close();
            } else {
                props.toggleModal(false);
            }
        }
    };

    const onCloseClick = (e) => {
        if (props.onCloseIconClick) {
            props.onCloseIconClick(e);
        } else {
            if (modalRef?.current) {
                modalRef.current?.close();
            } else {
                props.toggleModal(false);
            }
        }
    };

    return (
        <ModalContainer data-testid={props.dataTestId}>
            <ModalViewport onScroll={handleScroll} ref={ref} useThemeColor={props.useThemeColor}>
                <ModalBody isVerticalCentered={props.isVerticalCentered}>{props.children}</ModalBody>
                {(canCloseModal || props.rightHeaderComponent) && (
                    <LightNavBar align={props.rightHeaderComponent && !canCloseModal ? 'right' : 'space-between'}>
                        {canCloseModal && (
                            <LightDiskButton
                                to={props.linkTo ? props.linkTo : '#'}
                                onClick={onCloseClick}
                                iconName={props.isIconClose ? 'cross' : 'arrow-left'}
                                raised={isScroll}
                            />
                        )}
                        {props.rightHeaderComponent && props.rightHeaderComponent}
                    </LightNavBar>
                )}
            </ModalViewport>
        </ModalContainer>
    );
};

const mapStateToProps = ({ app }) => {
    return {
        isShowPopup: app.isShowPopup,
        isShowModal: app.isShowModal,
    };
};
export default connect(mapStateToProps, { toggleModal })(PromoModalComponent);

PromoModalComponent.propTypes = {
    canCloseModal: PropTypes.bool,
    isIconClose: PropTypes.bool, // когда нужен крестик вместо стрелки
    linkTo: PropTypes.string,
    onCloseIconClick: PropTypes.func,
    isVerticalCentered: PropTypes.bool,
    modalRef: PropTypes.shape({ current: PropTypes.object }),
    rightHeaderComponent: PropTypes.node,
    dataTestId: PropTypes.string,
    useThemeColor: PropTypes.bool,
    children: PropTypes.node,
    toggleModal: PropTypes.func,
    isShowPopup: PropTypes.bool,
    isShowModal: PropTypes.bool,
};
